import { toEPSG4326 } from '../proj/epsg3395';

function getViewPortBorders(map) {
  let extent = map.getView().calculateExtent(map.getSize());
  let extent3395 = toEPSG4326(extent);
  return {
    left: extent3395[0],
    // westLongitude
    bottom: extent3395[1],
    // southLatitude
    right: extent3395[2],
    // eastLongitude
    top: extent3395[3] // northLatitude

  };
}

export { getViewPortBorders };